"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Selector;
(function (Selector) {
    Selector["DAY"] = "day";
    Selector["MONTH"] = "month";
    Selector["YEAR"] = "year";
    Selector["NONE"] = "none";
})(Selector = exports.Selector || (exports.Selector = {}));
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
    KeyCode[KeyCode["ArrowLeft"] = 37] = "ArrowLeft";
    KeyCode[KeyCode["ArrowRight"] = 39] = "ArrowRight";
    KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Space"] = 32] = "Space";
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
    KeyCode[KeyCode["Tab"] = 9] = "Tab";
})(KeyCode = exports.KeyCode || (exports.KeyCode = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/date-picker/build/types.js
// module id = 30
// module chunks = 0 1